var _circle, _path, _circle2, _circle3, _circle4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1727,
    cy: 35.6066,
    r: 29.3934,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6252 38.474C39.1474 38.2353 30.7831 43.2533 30.5443 44.2093C30.3054 45.1654 37.331 58.8343 39.6252 63.8049C46.5075 62.2755 51.5737 58.2289 53.2465 56.3968C53.2465 56.3968 40.2666 38.7946 39.6252 38.474Z",
    fill: "#0062FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 21.9414,
    cy: 22.4631,
    r: 20.0735,
    fill: "#696974"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5074,
    cy: 20.0735,
    r: 20.0735,
    fill: "#B5B5BE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5076,
    cy: 20.0735,
    r: 16.25,
    fill: "#D5D5DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2215 35.0629C9.40463 32.243 6.16949 27.014 6.16949 21.0294C6.16949 12.0548 13.4449 4.77939 22.4195 4.77939C24.6481 4.77939 26.7719 5.22803 28.7056 6.0399C26.299 4.63101 23.4976 3.82346 20.5076 3.82346C11.5329 3.82346 4.25757 11.0988 4.25757 20.0735C4.25757 26.8195 8.36828 32.6054 14.2215 35.0629Z",
    fill: "#696974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1726 35.3677L30.5439 37.2795L33.1726 42.5368L36.7572 40.3861L33.1726 35.3677Z",
    fill: "#B5B5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.199c3ab797fc9309e32c849969f29c4c.svg";
export { ForwardRef as ReactComponent };